<div class="yf-row center gap-6">
  <ion-icon src="assets/app-icons/cronometro.svg" color="light" class="medium-icon"> </ion-icon>
  <ion-text color="light" [class]="$textClass()">
    {{$reservationQuickText()}}
  </ion-text>
</div>